
import React from 'react';
import { connect } from 'react-redux';
import { Button, Input } from 'reactstrap';
import { setLoginPage, setForgetPasswordDetails, setSiteKey, setUserRegisterDetails } from '../../General/Actions';
import Background from '../../ImageAssets/blueskyBackground.png';
import ValidateForm from '../../Utils/formValidation';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import SignUpComponent from './SignUpComponent';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';

class VoucherCodeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            verified: false,
            siteKey: "",
            billingName: "",
            accountId: "",
            voucherCode: "",
            phoneNumber: "NA"
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        // Network.executeAxios("getRecaptchaSiteKey", "GET", "", (resp) => {
        //         this.props.setSiteKey("siteKey", resp.SITEKEY);
        //         this.setState({
        //             isLoading:false
        //         })
        //     });

        window.addEventListener('message', this.processMessage, false);
        this.populateAccountDetails()
    }

    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    populateAccountDetails() {

        // if (this.props.userRegisterDetails.accountDetails.account_id) {
        //     this.setState({ accountId: this.props.userRegisterDetails.accountDetails.account_id })
        // }
        // if (this.props.userRegisterDetails.accountDetails.billing_name) {
        //     this.setState({ billingName: this.props.userRegisterDetails.accountDetails.billing_name })
        // }
        //var outstandingAmount = 32
        // try {
        //     outstandingAmount = this.props.userRegisterDetails.accountDetails.balance_details.outstanding_balance
        // } catch (err) {

        // }


        this.setState({
            accountId: "100070",
            billingName: "John Jacob",
            //amount:  GeneralUtils.formatNumberToStandardForm(outstandingAmount),
            diffAmount: "",
            //outstandingAmount: GeneralUtils.formatNumberToStandardForm(outstandingAmount)
        })
    }


    handleInputValueChange(name, value) {
        this.state[name] = value;
        this.setState({ "dummy": "dummy" })
    }

    loginButtonClicked() {
        this.props.setLoginPage("pageName", "login");
    }

    submitVoucherCode() {
        if (ValidateForm.inputFieldMandatoryCheck("otpCustomerIdContainer", this.props.locales, false)) {
            if (ValidateForm.inputFieldValueCompositionCheck("otpCustomerIdContainer", this.props.locales, false)) {
                var dataToSend = {
                    "serviceId": this.props.serviceId,
                    "voucherNum": this.state.voucherCode,
                }
                this.setState({ isLoading: true })
                Network.executeAxios("voucherRecharge", "POST", dataToSend, (voucherRechargeResponse) => {
                    this.setState({ isLoading: false })
                    var resultCode = "";
                    var resultDesc = "";
                    if (voucherRechargeResponse && voucherRechargeResponse.resultParam && voucherRechargeResponse.resultParam.resultCode) {
                        resultCode = voucherRechargeResponse.resultParam.resultCode
                        resultDesc = voucherRechargeResponse.resultParam.resultDescription;
                        if (resultCode === "1148") {
                            var temp = {
                                "billingName": this.state.billingName,
                                "accountId": this.state.accountId,
                                "amount": this.state.amount
                            }
                            this.props.setUserRegisterDetails("accountDetails", temp);
                            this.props.setLoginPage("pageName", "transactionForVoucher");
                        } else {
                            Swal.fire(resultDesc, "", "")
                        }
                    } else {
                        Swal.fire(this.props.locales.internalErrorTitleInSwal, "", "")
                    }
                });

            }
        }

    }

    render() {
        return (
            <div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        );
    }

    componentContent() {
        const forgetUsernameOuterMainContainerStyle = { height: (this.state.windowHeight) + 'px', display: "flex", flexDirection: "column", justifyContent: "space-between" };
        return (
            <div style={forgetUsernameOuterMainContainerStyle}>
                <div className="row m-0" style={{ flex: 1 }}>
                    <div className="col-md-6 p-0" >
                        <div className="leftPartBackgroundImage" style={{ display: "flex", flexDirection: "column", height: "100%", flex: 1, alignItems: "center", justifyContent: "center", background: `url(${Background}) 20%`, backgroundSize: 'cover' }}>
                            <SignUpComponent />
                        </div>
                    </div>
                    <div className="col-md-6 p-0" >
                        <div style={{ display: "flex", height: "100%", flex: 1, justifyContent: "center", backgroundColor: '#ffffff' }}>
                            {this.voucherComponent()}
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    voucherComponent() {
        return (
            <div className="loginPageLeftPart col-md-12 row p-0 m-0">
                <div className="col-md-12 row py-5 m-0 my-5 d-none d-sm-block">

                </div>
                <div className="col-md-12 row m-0">
                    <div className="col-md-1"></div>
                    <div className="col-md-9 pl-sm-5 pl-2 pt-4" id="otpCustomerIdContainer">
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 400 }}>{this.props.locales.HiHeadingInVoucherComponent}</div>
                        <div className="col-md-12" style={{ fontSize: 30, color: '#404042', fontWeight: 600 }}>{this.state.billingName}<span style={{ fontSize: 21, paddingLeft: 5, fontWeight: 500 }}>({this.state.accountId})</span> </div>
                        <div className="col-md-12 pb-4 pt-3" style={{ fontSize: 18, fontWeight: 300, color: '#404042' }}>{this.props.locales.enterVoucherCodeTextInVoucherCodePart}</div>
                        <div className="form-group col-md-12" >
                            <label className="d-none animated slideInUp m-0" style={{ color: '#a3b4bc', fontSize: 12, position: 'absolute' }}>{this.props.locales.enterCodeInPlaceHolder}</label>
                            <Input type="text" name="code" autoComplete="new-password" style={{ color: '#404042' }}
                                className="loginCredItem input_data mandatoryFieldSpecial pt-4 pb-3" placeholder={this.props.locales.enterCodeInPlaceHolder}
                                onChange={(event) => this.handleInputValueChange("voucherCode", event.target.value)}
                                value={this.state.voucherCode}
                                onKeyUp={(event) => this.displayLabel(event, this.state.voucherCode, this.props.locales.enterCodeInPlaceHolder)} />
                            <div className="errorDesc" style={{ color: 'red', fontSize: 12, fontWeight: 400, position: 'absolute' }}></div>
                        </div>

                        <div className="col-md-12 pt-3">
                            <Button className="loginPageLoginButton" disabled={this.state.voucherCode == undefined || this.state.voucherCode == "" ? true : false} onClick={() => { this.submitVoucherCode() }}>
                                {this.props.locales.addButtonTextInVoucherCodePart}
                            </Button>
                        </div>

                        <div className="d-flex col-md-12 justify-content-center pb-5" style={{ visibility: 'hidden' }}>
                            <div style={{ color: '#0285CA', fontSize: 16, fontWeight: 'bold', cursor: 'pointer' }} onClick={() => { this.signInLinkClicked() }}> {this.props.locales.signInWithOtptInOtpSignInCustomerIdPart}</div>
                        </div>
                    </div>
                    <div className="col-md-2"></div>
                </div>
            </div>
        )
    }

    displayLabel(event, value, placeHolderText) {
        if (value != "") {
            event.target.previousSibling.classList.remove('d-none');
            event.target.placeholder = "";
        } else {
            event.target.previousSibling.classList.add('d-none');
            event.target.placeholder = placeHolderText;
        }
    }

    signInLinkClicked() {
        this.props.setLoginPage("pageName", "customerIdForOTP");
    }

}
const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        siteKey: state.siteKey,
        userRegisterDetails: state.userRegisterDetails
    }
}
function mapDispatchToProps(dispatch) {
    return {
        setLoginPage: function (key, payload) {
            dispatch(setLoginPage(key, payload));
        },
        setForgetPasswordDetails: function (key, payload) {
            dispatch(setForgetPasswordDetails(key, payload));
        },
        setSiteKey: function (key, payload) {
            dispatch(setSiteKey(key, payload));
        },
        setUserRegisterDetails: function (key, payload) {
            dispatch(setUserRegisterDetails(key, payload))
        }
    }
}

const VoucherCodeComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(VoucherCodeComponent)


export default VoucherCodeComponentContainer;